import React from 'react';
import { Link } from 'react-router-dom';
import { COMPILED_LABEL } from '../../data/sources';
import { BRAND } from '../../data/brand';
import { allNavItems } from '../../data/navigation';
import { Wordmark } from './Wordmark';
export function SiteFooter() {
  return <footer className="relative mt-20 border-t border-line bg-surface" data-id="element-394" data-mp="xyuirdmlcm15">
      <div className="mx-auto grid max-w-[1400px] gap-10 px-5 py-10 md:grid-cols-[1.3fr_1fr_1fr] md:px-8" data-id="element-395" data-mp="xz48r17myt6u">
        <div data-id="element-396" data-mp="1lmcd9gx8py7t">
          <Wordmark showDomain={false} data-id="element-397" data-mp="1qni8bledhxki" />
          <p className="mt-3 max-w-md text-sm leading-relaxed text-muted" data-id="element-398" data-mp="1qmgvpchpl30o">
            Data as of {COMPILED_LABEL} — every figure sourced. Ranges are explicit assumptions, clearly labeled.
          </p>
          <p className="mt-2 font-mono text-[11.5px] text-faint" data-id="element-399" data-mp="1goay372xqj1m">Published by {BRAND.domain}</p>
        </div>
        <div data-id="element-400" data-mp="17smtl8bu37e">
          <h2 className="text-[13px] font-medium text-ink" data-id="element-401" data-mp="17aehq8e3yj4">Corrections policy</h2>
          <p className="mt-2 text-[13px] leading-relaxed text-muted" data-id="element-402" data-mp="5ayn8c8rd05y">
            Every figure carries a “Challenge this number” link in its source tooltip. Send a better source and we re-check it; confirmed corrections are dated in the{' '}
            <Link to="/changelog" className="text-ink underline decoration-line underline-offset-2 hover:decoration-machine" data-id="element-403" data-mp="26w6s5hz43f7l">
              Census Bulletin
            </Link>
            . Write to{' '}
            <a href={`mailto:${BRAND.corrections}`} className="text-ink underline decoration-line underline-offset-2 hover:decoration-machine" data-id="element-404" data-mp="2gucrbrtja78r">
              {BRAND.corrections}
            </a>
            .
          </p>
        </div>
        <nav aria-label="Footer" data-id="element-405" data-mp="2qkfmnyo4nxa9">
          <ul className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm" data-id="element-406" data-mp="2qjcs9grljcpl">
            {allNavItems.map(item => <li key={item.to} data-id="element-407" data-mp="2ln5uib9ct7iq">
                <Link to={item.to} className="text-muted transition-colors duration-150 hover:text-ink" data-id="element-408" data-mp="2zkaym5pibwbc">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </nav>
      </div>
      <Link to="/frontier-7sigma" aria-label="." className="absolute bottom-2 right-3 px-1 font-mono text-xs text-faint/60 hover:text-faint focus-visible:text-ink" data-id="element-409" data-mp="1s9mnzeg3q5zg">
        .
      </Link>
    </footer>;
}